export default __webpack_public_path__ + "static/media/grafema_martini-contest_09.b862024e.jpg";